import { Drawer, Modal } from "antd";
import React, { ReactElement, useState } from "react";
import AddBtn from "../common/AddBtn";
import AddVehicleType from "./AddVehicleType";

const TopHeading = ({ total, refetch }: any): ReactElement => {
  const [visible, setvisible] = useState<boolean>(false);

  const showDrawer = () => {
    setvisible(true);
  };

  const onClose = () => {
    setvisible(false);
    refetch();
  };

  return (
    <div className="top-heading-products top-heading-content">
      <div className="container-fluid">
        <div className="row d-flex-sb mb-15">
          <div className="col-lg-6 col-md-6 no-padding">
            <div className="page-heading-content">
              <h2 className="d-flex-l wrap d-flex-nowrap d-flex-base">
                Vehicle Type
                <span className="d-flex-l ml-1">{total || 0} Type(s)</span>
              </h2>
            </div>
          </div>

          <div className="single-button">
            <AddBtn onClick={showDrawer} />
          </div>
          <Modal
            title="Add Vehicle Type"
            visible={!!visible}
            onCancel={onClose}
            okText={`Submit`}
            footer={false}
          >
            <AddVehicleType onCloseMethod={onClose} />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default TopHeading;
